import { render } from "./AdminJournees.vue?vue&type=template&id=15a2d40b&scoped=true"
import script from "./AdminJournees.vue?vue&type=script&lang=js"
export * from "./AdminJournees.vue?vue&type=script&lang=js"

import "./AdminJournees.vue?vue&type=style&index=0&id=15a2d40b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a2d40b"]])

export default __exports__